/**
 * The initial state of the module.
 *
 * @type {Object}
 */
export const state = {
	data: {
		steps: [],
		total: 0,
		salary: 0,
		savingsNeeded: 0,
		isEstimated: false,
		retirementPeriod: 0,
		incomeForRetirement: 0,
		salaryPercentForRetirement: 0
	}
};

/**
 * The supported mutations types.
 *
 * @type {String}
 */
export const ROW_UPDATE_DATA = 'row/update-data';
export const STEP_SET_META = 'step/set-meta';
export const STEP_UPDATE_TOTAL = 'step/update-total';
export const GRAND_TOTAL_UPDATE = 'grand-total/update';
export const ESTIMATION_CALCULATED = 'estimation/calculated';
export const SALARY_SET = 'salary/set';
export const RETIREMENT_PERIOD_SET = 'retirement-period/set';

/**
 * The supported actions.
 *
 * @type {Object}
 */
export const actions = {
	updateRow({commit}, payload) {
		commit(ROW_UPDATE_DATA, payload);
		commit(STEP_UPDATE_TOTAL, payload);
		commit(GRAND_TOTAL_UPDATE, payload);
	},

	setStepMeta({commit}, payload) {
		commit(STEP_SET_META, payload);
	},

	setSalary({commit}, payload) {
		commit(SALARY_SET, payload);
	},

	setRetirementPeriod({commit}, payload) {
		commit(RETIREMENT_PERIOD_SET, payload);
	},

	setCalculated({commit}, payload) {
		commit(ESTIMATION_CALCULATED, payload);
	}
};

/**
 * The mutations of the state.
 *
 * @type {Object}
 */
export const mutations = {
	[ROW_UPDATE_DATA](state, payload) {
		const {
			stepIndex,
			rowIndex,
			title,
			spendFrequency,
			period,
			amount,
			total
		} = payload;
		const currentData = state.data.steps[stepIndex].rows[rowIndex];
		state.data.steps[stepIndex].rows[rowIndex] = {
			...currentData,
			rowIndex,
			title,
			total,
			spendFrequency,
			period,
			amount
		};
	},

	[STEP_SET_META](state, {title, color}) {
		state.data.steps.push({
			title,
			color,
			total: 0,
			rows: []
		});
	},

	[STEP_UPDATE_TOTAL](state, {stepIndex}) {
		state.data.steps[stepIndex].total = state.data.steps[
			stepIndex
		].rows.reduce((sum, {total}) => parseFloat(sum) + parseFloat(total), 0);
	},

	[GRAND_TOTAL_UPDATE](state) {
		state.data.total = state.data.steps.reduce(
			(sum, {total}) => parseFloat(sum) + parseFloat(total),
			0
		);
	},

	[SALARY_SET](state, salary) {
		state.data.salary = parseFloat(salary);
	},

	[RETIREMENT_PERIOD_SET](state, retirementPeriod) {
		state.data.retirementPeriod = parseFloat(retirementPeriod);
	},

	[ESTIMATION_CALCULATED](state) {
		state.data.isEstimated = true;
	}
};

/**
 * Get some information from the state.
 *
 * @type {Object}
 */
export const getters = {
	total: state => state.data.total,
	steps: state => state.data.steps,
	salary: state => state.data.salary,
	stepTotal: state => stepIndex => state.data.steps[stepIndex].total,
	isEstimated: state => state.data.isEstimated,
	retirementPeriod: state => state.data.retirementPeriod,
	totalIncomeNeeded: state => state.data.retirementPeriod * state.data.total
};
